import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Field, Toggle } from "./AdminMovies";
import { Modal } from "./AdminSeries";
import FileUpload from "../../components/FileUpload";

const empty = {
  channelName: "", logoUrl: "", category: "Entertainment", country: "", language: "",
  streamUrl: "", currentProgram: "", isLive: true, isFeatured: false, isKidsSafe: false,
};

export default function AdminChannels() {
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState(null);

  const load = () => api.get("/channels").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (edit.id) await api.put(`/admin/channels/${edit.id}`, edit);
    else await api.post("/admin/channels", edit);
    toast.success("Saved");
    setEdit(null);
    load();
  };

  const del = async (id) => {
    if (!window.confirm("Delete channel?")) return;
    await api.delete(`/admin/channels/${id}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div data-testid="admin-channels-page">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-black tracking-tighter" style={{ fontFamily: "Outfit" }}>Live TV Channels</h1>
          <p className="text-[#888] text-sm">{items.length} channels broadcasting</p>
        </div>
        <button onClick={() => setEdit({ ...empty })} className="btn-primary" data-testid="add-channel-btn"><Plus size={16} /> Add Channel</button>
      </div>
      <div className="bg-[#0d0d0d] border border-white/5 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#080808] text-[#888] text-xs uppercase tracking-wider">
            <tr><th className="text-left p-3">Logo</th><th className="text-left p-3">Channel</th><th className="text-left p-3">Category</th><th className="text-left p-3">Country</th><th className="text-left p-3">Now Playing</th><th className="text-left p-3">Status</th><th className="text-right p-3">Actions</th></tr>
          </thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} className="border-t border-white/5 hover:bg-white/5">
                <td className="p-3">{c.logoUrl && <img src={c.logoUrl} alt="" className="w-10 h-10 object-cover rounded" />}</td>
                <td className="p-3 font-medium">{c.channelName}</td>
                <td className="p-3 text-[#aaa]">{c.category}</td>
                <td className="p-3 text-[#aaa]">{c.country}</td>
                <td className="p-3 text-[#aaa]">{c.currentProgram}</td>
                <td className="p-3">
                  {c.isLive && <span className="live-badge">LIVE</span>}
                  {c.isKidsSafe && <span className="text-[10px] bg-blue-500/20 text-blue-400 px-1.5 py-0.5 rounded ml-1">KIDS</span>}
                </td>
                <td className="p-3 text-right">
                  <button onClick={() => setEdit(c)} className="text-[#aaa] hover:text-white p-1"><Pencil size={16} /></button>
                  <button onClick={() => del(c.id)} className="text-[#aaa] hover:text-[#E50914] p-1 ml-1"><Trash2 size={16} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {edit && (
        <Modal title={edit.id ? "Edit Channel" : "Add Channel"} onClose={() => setEdit(null)} onSave={save}>
          <Field label="Channel Name" value={edit.channelName} onChange={(v) => setEdit({ ...edit, channelName: v })} />
          <Field label="Current Program" value={edit.currentProgram} onChange={(v) => setEdit({ ...edit, currentProgram: v })} />
          <div className="grid grid-cols-3 gap-3">
            <Field label="Category" value={edit.category} onChange={(v) => setEdit({ ...edit, category: v })} />
            <Field label="Country" value={edit.country} onChange={(v) => setEdit({ ...edit, country: v })} />
            <Field label="Language" value={edit.language} onChange={(v) => setEdit({ ...edit, language: v })} />
          </div>
          <FileUpload label="Logo" value={edit.logoUrl} onChange={(v) => setEdit({ ...edit, logoUrl: v })} accept="image/*" kind="image" />
          <Field label="Stream URL (m3u8)" value={edit.streamUrl} onChange={(v) => setEdit({ ...edit, streamUrl: v })} />
          <div className="flex gap-6">
            <Toggle label="Live" checked={edit.isLive} onChange={(v) => setEdit({ ...edit, isLive: v })} />
            <Toggle label="Featured" checked={edit.isFeatured} onChange={(v) => setEdit({ ...edit, isFeatured: v })} />
            <Toggle label="Kids-safe" checked={edit.isKidsSafe} onChange={(v) => setEdit({ ...edit, isKidsSafe: v })} />
          </div>
        </Modal>
      )}
    </div>
  );
}
